const getSource = (): string =>
  // e.g. https://app.sleepiolocal.com
  window.location.origin;

export { getSource };
